

import React from "react";
import { Link, StaticQuery } from "gatsby";
import styled from "styled-components";
import Img from "gatsby-image"
import { useMediaQuery } from "react-responsive";
import Quotes from "../../assets/img/quotes.svg";


const SingleReviewInner = styled.div`
  .recenze {
    background: #F3F1EC;
    padding: 60px 0;

    @media (max-width: 899px) {
      padding: 30px 0;
    }

    .recenzeInner {
      display: flex;
      align-items: stretch;
      background: #FFFFFF;
      box-shadow: 0 9px 20px 0 rgba(0,0,0,0.07);
      border-radius: 20px;
      overflow: hidden;
      max-width: 1150px;
      margin: 0 auto;
      width: calc(100% - 100px);

      @media (max-width: 899px) { 
        display: block;
        width: calc(100% - 50px - 80px);
        max-width: 520px;
        padding: 40px;
      }

      @media (max-width: 500px) { 
        display: block;
        padding: 25px;
        width: calc(100% - 50px - 50px);
      }

      .left {
        width: calc(100% - 450px);
        display: flex;
        align-items: center;

        @media (max-width: 1100px) { 
          width: calc(100% - 300px);
        }

        @media (max-width: 899px) { 
          width: 100%;
        }

        .leftInner {
          max-width: 560px;
          margin: 0 auto;
          display: block;
          padding: 60px 0;
          width: calc(100% - 160px);

          @media (max-width: 1100px) { 
            width: calc(100% - 100px);
          }

          @media (max-width: 899px) { 
            padding: 0;
            width: calc(100%);
          }

          img {
            @media (max-width: 899px) { 
              width: 39px;
            }
          }

          p {
            font-family: NewKansas;
            font-size: 26px;
            color: #000000;
            line-height: 39px;
            margin-top: 22px;
            margin-bottom: 25px;

            @media (max-width: 1100px) { 
              font-size: 20px;
              line-height: 32px;  
            }

            @media (max-width: 899px) { 
              font-size: 21px;
              line-height: 33px;
              margin-top: 15px;
              margin-bottom: 25px;
            }

            @media (max-width: 500px) { 
              font-size: 19px;
              line-height: 30px;
            }

            span {
              font-family: NewKansas-Bold;
            }
          }

          .zakaznik {
            font-family: Visuelt-Regular;
            font-size: 16px;
            color: #5B5B5B;
          }
        }
      }

      .right {
        width: calc(450px);
        background: none;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        @media (max-width: 899px) { 
          width: 100%;
          display: flex;
          align-items: center;
          background: none;
          justify-content: flex-start;
        }

        span {
          display: block;

          &:first-child {
            font-family: Visuelt-Medium;
            font-size: 18px;
            color: #000000;
            line-height: 27px;  
          }

          &:last-child {
            font-family: Visuelt-Regular;
            font-size: 16px;
            color: #5B5B5B;
            line-height: 27px;
          }
        }

        .obrazek {
          height: 100%;
          margin-right: 85px;

          @media (max-width: 1100px) {
            margin-right: 50px;
          }

          @media (max-width: 899px) {
            margin-right: 0;
            margin-top: 40px;
          }
        }
      }
    }
  }
`;


const SingleReview = ({data}) => {

  const isPlus900 = useMediaQuery({
    query: '(min-width: 899px)'
  });


  return (

    <StaticQuery
      query={graphql`
        query {
          recenzeSample: file(relativePath: { eq: "zakaznice4.png" }) {
            childImageSharp {
              fixed(width: 340) {
                ...GatsbyImageSharpFixed_noBase64
              }
            }
          }
      
          recenzeSampleSmall: file(relativePath: { eq: "zakaznice4.png" }) {
            childImageSharp {
              fixed(width: 200) {
                ...GatsbyImageSharpFixed_noBase64
              }
            }
          }
        }
      `}
      render={data => (
        <SingleReviewInner >
          <div className="recenze">
            <div className="recenzeInner">
              <div className="left">
                <div className="leftInner">
                  <img src={Quotes} alt="" />
                  <p>Zaměstnanci Goodbye byli <span>maximálně ochotní, všechno nám vysvětlili a pomohli nám zvládnout situaci,</span> která byla od začátku pro celou rodinu velkým neštěstím. Děkujeme.</p>
                  <span className="zakaznik">Jana Č., Zákaznice</span>
                </div>
              </div>
              <div className="right">
                {(isPlus900) ?
                  <Img className="obrazek" alt="Recenze fotka" fixed={data.recenzeSample.childImageSharp.fixed} />
                :
                  <Img className="obrazek" alt="Recenze fotka" fixed={data.recenzeSampleSmall.childImageSharp.fixed} />
                }
              </div>
            </div>
          </div>
        </SingleReviewInner>
      )}
    />
  );
}

export default SingleReview;


